import { Button } from "@/components/ui/button";
import { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import {
  PaymentStatusMapping,
  OrderStatusMapping,
} from "../models/order.model";
import { Checkbox } from "@/components/ui/checkbox";
import { CaretSortIcon, DotsHorizontalIcon } from "@radix-ui/react-icons";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Eye } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const ordersTableColumns: ColumnDef<any>[] = [
  // {
  //   id: "select",
  //   header: ({ table }) => (
  //     <Checkbox
  //       checked={
  //         (table.getIsAllPageRowsSelected() ? true : false) ||
  //         (table.getIsSomePageRowsSelected() && "indeterminate" ? true : false)
  //       }
  //       onCheckedChange={(value: any) =>
  //         table.toggleAllPageRowsSelected(!!value)
  //       }
  //       aria-label="Select all"
  //     />
  //   ),
  //   cell: ({ row }) => (
  //     <Checkbox
  //       checked={row.getIsSelected()}
  //       onCheckedChange={(value: any) => row.toggleSelected(!!value)}
  //       aria-label="Select row"
  //     />
  //   ),
  //   enableSorting: false,
  //   enableHiding: false,
  // },
  {
    accessorKey: "service",
    header: () => (
      <Button
        variant="ghost"
        //   onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Service
        {/* <CaretSortIcon className="ml-2 h-4 w-4" /> */}
      </Button>
    ),
    cell: ({ row }) => (
      <div>{(row.getValue("service") || "-") as React.ReactNode}</div>
    ),
  },
  {
    accessorKey: "addOns",
    header: () => (
      <Button
        variant="ghost"
        //   onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Addons
        {/* <CaretSortIcon className="ml-2 h-4 w-4" /> */}
      </Button>
    ),
    cell: ({ row }) => <div>{row.getValue("addOns") as React.ReactNode}</div>,
  },
  {
    accessorKey: "plateNumber",
    header: () => (
      <Button
        variant="ghost"
        //   onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Car Reg No
        {/* <CaretSortIcon className="ml-2 h-4 w-4" /> */}
      </Button>
    ),
    cell: ({ row }) => (
      <div>{row.getValue("plateNumber") as React.ReactNode}</div>
    ),
  },
  {
    accessorKey: "createdAt",
    header: () => (
      <Button
        variant="ghost"
        // onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Date Created
        {/* <CaretSortIcon className="ml-2 h-4 w-4" /> */}
      </Button>
    ),
    cell: ({ row }) => (
      // <div>{row.getValue("createdAt") as React.ReactNode}</div>
      <div className="uppercase">
        {new Date(row.getValue("createdAt") as string).toLocaleString("en-GM", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })}
      </div>
    ),
  },
  {
    accessorKey: "company",
    header: () => (
      <Button
        variant="ghost"
        //   onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Company
        {/* <CaretSortIcon className="ml-2 h-4 w-4" /> */}
      </Button>
    ),
    cell: ({ row }) => <div>{row.getValue("company") as React.ReactNode}</div>,
  },
  {
    accessorKey: "totalCost",
    header: () => (
      <Button
        variant="ghost"
        //   onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Total Cost
        {/* <CaretSortIcon className="ml-2 h-4 w-4" /> */}
      </Button>
    ),
    cell: ({ row }) => (
      <div>KES {row.getValue("totalCost") as React.ReactNode}</div>
    ),
  },
  {
    accessorKey: "paymentStatus",
    header: () => (
      <Button
        variant="ghost"
        //   onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Payment
        {/* <CaretSortIcon className="ml-2 h-4 w-4" /> */}
      </Button>
    ),
    cell: ({ row }) => {
      const paymentStatus = row.getValue("paymentStatus");
      return (
        <div
          className={`capitalize ${
            paymentStatus === "paid"
              ? "text-success"
              : paymentStatus === "not_paid"
              ? "text-error"
              : ""
          }`}
        >
          {
            PaymentStatusMapping[
              row.getValue("paymentStatus") as string
            ] as React.ReactNode
          }
        </div>
      );
    },
  },
  {
    accessorKey: "status",
    header: () => (
      <Button
        variant="ghost"
        //   onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Status
        {/* <CaretSortIcon className="ml-2 h-4 w-4" /> */}
      </Button>
    ),
    cell: ({ row }) => {
      const status = row.getValue("status");
      return (
        <div
          className={`capitalize ${
            status === "in_progress"
              ? "text-primary"
              : status === "cancelled"
              ? "text-error"
              : status === "pending"
              ? "text-warning"
              : status === "completed"
              ? "text-success"
              : status === "hold"
              ? "text-blue-600"
              : ""
          }`}
        >
          {OrderStatusMapping[status as string] as React.ReactNode}
        </div>
      );
    },
  },
  {
    id: "actions",
    enableHiding: false,
    header: ({ column }) => (
      <Button
        variant="ghost"
        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Actions
      </Button>
    ),
    cell: ({ row }) => {
      return (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
            {/* <Link to={`/app/orders/${order.id}`}> */}
            <Link to={`/app/orders/${row.original.id}`}>
              <Button variant="outline" className="h-8 w-8 p-0">
                <Eye className="h-4 w-4" />
              </Button>
              </Link>
            </TooltipTrigger>
            <TooltipContent>
              <p>View order details</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    },
  },
];
